/**
 * @author: liaosir
 * @description: 传递表头headers，需要导出的数据data以及文件名filename，导出excel表格
 */
import React, { useState, useEffect, useMemo, ReactNode } from 'react';

interface Header {
  title: string | ReactNode;
  dataIndex: string;
  key: string;
}

export type ExportHeaders = Header[];

/**
 * @description 将数组导出为excel文件
 * @param headers Array 表头数据
 * @param data Array 需要导出的数据
 * @param fileName String 文件名
 */
const exportExcel = (headers: ExportHeaders, data: [], fileName = 'demo.xlsx') => {
  const _headers =
    headers.length > 0 &&
    headers
      .map((item, i) =>
        Object.assign({}, { key: item.key, title: item.title, position: String.fromCharCode(65 + i) + 1 }),
      )
      .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { key: next.key, v: next.title } }), {});
  const _data =
    data.length > 0 &&
    data
      .map((item, i) => {
        return headers.map((key, j) => {
          return Object.assign({}, { content: item[key.key], position: String.fromCharCode(65 + j) + (i + 2) });
        });
      })
      // 对刚才的结果进行降维处理（二维数组变成一维数组）
      .reduce((prev, next) => prev.concat(next))
      // 转换成 worksheet 需要的结构
      .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { v: next.content } }), {});

  // 合并 headers 和 data
  const output = Object.assign({}, _headers, _data);
  // 获取所有单元格的位置
  const outputPos = Object.keys(output);
  // 计算出范围 ,["A1",..., "H2"]
  const ref = `${outputPos[0]}:${outputPos[outputPos.length - 1]}`;
  // 列宽度范围设置
  const col = new Array(headers.length).fill({ wpx: 150 });

  // 构建 workbook 对象
  const wb = {
    SheetNames: ['mySheet'],
    Sheets: {
      mySheet: Object.assign({}, output, {
        '!ref': ref,
        '!cols': col,
      }),
    },
  };
  // 导出 Excel
  // import XLSX from 'xlsx';
  import('xlsx').then((res) => {
    res.default.writeFile(wb, fileName);
  });

  // XLSX.writeFile(wb, fileName);
};

export { exportExcel };
